const Toast = {
	methods: {
		showToastSuccess: function (title, text, translateTitle = true, translateText = true) {
			this.$notify({
				group: 'toast',
				type: 'success',
				duration: 5000,
				speed: 1000,
				title: translateTitle ? this.$t('Toast.Title.' + title) : title,
				text: translateText ? this.$t('Toast.Text.' + text) : text,
			})
		},
		showToastInfo: function (title, text, translateTitle = true, translateText = true) {
			this.$notify({
				group: 'toast',
				type: 'info',
				duration: 5000,
				speed: 1000,
				title: translateTitle ? this.$t('Toast.Title.' + title) : title,
				text: translateText ? this.$t('Toast.Text.' + text) : text,
			})
		},
		showToastWarn: function (title, text, translateTitle = true, translateText = true) {
			this.$notify({
				group: 'toast',
				type: 'warn',
				duration: 5000,
				speed: 1000,
				title: translateTitle ? this.$t('Toast.Title.' + title) : title,
				text: translateText ? this.$t('Toast.Text.' + text) : text,
			})
		},
		showToastError: function (title, text, translateTitle = true, translateText = false) {
			this.$notify({
				group: 'toast',
				type: 'error',
				duration: 5000,
				speed: 1000,
				title: translateTitle ? this.$t('Toast.Title.' + title) : title,
				text: translateText ? this.$t('Toast.Text.' + text) : text,
			})
		},
	},
}

export default Toast



// WEBPACK FOOTER //
// ./src/mixins/Toast.js